import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AirportContractListAttachmentRecord, AttachmentDownloadUrl, FuelSupplierAttachmentGetRecord } from '../types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AirportContractListAttachmentService {
  private readonly baseUrl = '/api/airport-contract-list';

  constructor(private http: HttpClient) {}

  getAttachments(
      airportContractListId: number
    ): Observable<AirportContractListAttachmentRecord[]> {
      return this.http.get<AirportContractListAttachmentRecord[]>(
        `${this.baseUrl}/${airportContractListId}/attachment`
      );
    }
  
    getAttachmentDownloadUrl(
      attachmentId: number
    ): Observable<AttachmentDownloadUrl> {
      return this.http.get<AttachmentDownloadUrl>(
        `${this.baseUrl}/attachment/${attachmentId}/download-url`
      );
    }
  
    uploadAttachments(airportContractListId: number, attachments: File[]) {
      const formData = new FormData();
      attachments.forEach(attachment => formData.append('attachments', attachment));
  
      return this.http.post<any>(
        `${this.baseUrl}/${airportContractListId}/attachment`,
        formData
      );
    }
  
    deleteAttachments(attachmentIds: number[]): Observable<any> {
      const request = {
        attachmentIds: attachmentIds
      }
      return this.http.delete(`${this.baseUrl}/attachment`, { body: request });
    }
}
